import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

import AdminLayout from '../../layouts/adminLayout';
import { APP_ROLES, RequireAuth, RequireRole } from '../../features/auth';
import SurfaceRoleGate from '../../features/auth/components/SurfaceRoleGate';
import StaffSignInPage from '../../features/auth/pages/StaffSignInPage';
import { FEATURE_ROUTES } from '../routeConstants';
import {
  AdminPage,
  ForbiddenPage,
  ObservabilityPage,
  childPath,
  route
} from './routeCommon';

export const ownerManifestRoutes: RouteObject[] = [
  { path: childPath(FEATURE_ROUTES.auth.forbidden), element: route(<ForbiddenPage />) },
  { index: true, element: route(<StaffSignInPage homePath={FEATURE_ROUTES.admin.home} />) },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <SurfaceRoleGate />,
        children: [
          {
            element: <RequireRole allowed={[APP_ROLES.admin, APP_ROLES.owner, APP_ROLES.affiliate]} />,
            children: [
              {
                element: <AdminLayout />,
                children: [
                  { path: childPath(FEATURE_ROUTES.admin.home), element: route(<AdminPage />) },
                  { path: 'admin/approvals', element: <Navigate to="/admin?module=approvals" replace /> },
                  {
                    path: 'admin/analytics',
                    element: <Navigate to="/admin?module=dashboard" replace />
                  },
                  {
                    path: 'admin/observability',
                    element: route(<ObservabilityPage />)
                  },
                  {
                    path: childPath(FEATURE_ROUTES.admin.ownerAlias),
                    element: <Navigate to="/admin?module=dashboard" replace />
                  },
                  {
                    path: childPath(FEATURE_ROUTES.admin.managementAlias),
                    element: <Navigate to="/admin?module=dashboard" replace />
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  { path: '*', element: <Navigate to={FEATURE_ROUTES.admin.home} replace /> }
];
